import React from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";

/**
 * Redirect an old inventory URL to its standard one, keeping the query string —
 * e.g. /supplier/hotels/edit/12 → /supplier/hotels/12/edit. Inventory routes are
 * /supplier/{type}/new, /:id (view) and /:id/edit; the old shapes stay reachable so
 * bookmarks and links from elsewhere keep working.
 */
const LegacyRedirect: React.FC<{ to: (params: Record<string, string | undefined>) => string }> = ({ to }) => {
  const params = useParams();
  const { search } = useLocation();
  return <Navigate to={`${to(params)}${search}`} replace />;
};

export default LegacyRedirect;
